import { useParams, Link, Navigate } from "react-router-dom";
import Seo from "@/components/Seo";
import PlaceholderNote from "@/components/PlaceholderNote";
import { POLICIES, POLICY_NAV } from "@/data/policies";

export default function PolicyPage() {
  const { slug } = useParams();
  const policy = POLICIES[slug];

  if (!policy) return <Navigate to="/" replace />;

  return (
    <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
      <Seo
        title={`${policy.title} | CA HVAC Direct`}
        description={policy.intro}
        path={`/policies/${slug}`}
      />
      <nav className="text-xs text-slate-500" aria-label="Breadcrumb">
        <Link to="/" className="hover:text-sky-700">Home</Link>
        <span className="px-1.5">/</span>
        <span className="text-slate-700">{policy.title}</span>
      </nav>

      <h1 className="mt-4 font-heading text-4xl font-black tracking-tight text-slate-900">{policy.title}</h1>
      <p className="mt-3 text-slate-600">{policy.intro}</p>

      {policy.placeholder && (
        <PlaceholderNote className="mt-6">
          This policy contains placeholder text. Final, business-specific and legally reviewed language
          will be provided by CA HVAC Direct before launch.
        </PlaceholderNote>
      )}

      <div className="mt-10 space-y-8">
        {policy.sections.map((s) => (
          <section key={s.h}>
            <h2 className="font-heading text-xl font-bold tracking-tight text-slate-900">{s.h}</h2>
            <p className="mt-2 text-slate-600">{s.b}</p>
          </section>
        ))}
      </div>

      <div className="mt-12 border-t border-slate-200 pt-8">
        <h3 className="mb-3 text-xs font-bold uppercase tracking-widest text-slate-400">Other policies</h3>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
          {POLICY_NAV.filter((p) => p.slug !== slug).map((p) => (
            <Link key={p.slug} to={`/policies/${p.slug}`} className="text-sky-700 hover:underline">
              {p.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
